import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vg_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("vg_token");
      localStorage.removeItem("vg_user");
      if (window.location.pathname !== "/auth" && window.location.pathname !== "/") {
        window.location.href = "/auth";
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Lightweight analytics tracker. Fires-and-forgets to keep the UI snappy.
// Usage: track("guided_prayer_started", { slug: "peace" })
export const track = (name, properties = {}) => {
  try {
    const hasToken = !!localStorage.getItem("vg_token");
    const url = hasToken ? "/events" : "/events/anonymous";
    api.post(url, { name, properties }).catch(() => {});
  } catch { /* never block UI on analytics */ }
};
